export default "__VITE_ASSET__CMs0xcrc__"